// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* conteneur englobant l'ensemble des informations */
table{
    border-collapse:collapse;
}
table,
tr,
td,
div {
    page-break-inside: avoid;
}
.EtiquetteRaquettes{
  width: 11.5cm;
  height: 4cm;
  border: solid 0.1px;
}
.EtiquetteRaquettesSize{
	width: 11.5cm;
	height: 4cm;
}
.dlpro-manufacturer-name-custom{
	font-size: 10px;
    width: 100%;
}
.logoP2BouPromoRaquettesPromo {
        background-color: #e8182e;
    color: #fff;
    border-radius: 50px;
    display: flex;
    align-items: center;
    justify-content: center;
    width: 60%;
    height: 25px;
    font-size: 10px;
    font-weight: bold;
}
.logoP2BouPromoRaquettesPrixDebad{
	   display: flex;
    justify-content: center;
      align-items: end;
}
.logoP2BouPromoRaquettesPrixDebad span {
    font-size: 13px;
    margin-right: 2px;
    line-height: 15px;
}
.logoP2BouPromoRaquettesPrixDebad img {
    width: 40%;
}
.no-margin-print{margin-top: 20px;}
.no-margin-top-left{
	margin-top: 20px;
	margin-left: 25px;
}
.conteneurEtiquetteRaquettes {
	display: block;
	width: 11.5cm;
	height: 4cm;
}
.no-padding-print{
	padding-left: 90px !important;
}
.conteneurCaracteristiquesRaquettes {
	width: 65%;
    float: left;
	position: relative;
	height: 100%;
}
.raquettesCheckGreen {
    position: absolute;
    top: 5px;
    left: 5px;
}
.raquettesCheckGreen img{
    width: 20px;
}  
.raquettesBlockTop{
	position: absolute;
    top: 20px;
    left: 50%;
    transform: translateX(-50%);
	    margin-top: -10px;
}
.raquettesBlockTop img{
	width: 110px;
}
.raquettesBlockCenter{
	position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    width: 100%;
    text-align: center;
    margin: 10px 0;
}
.bigSizeEtiquetteRaquettes {
     font-size: 18px;
    font-weight: 600;
    width: 90%;
    margin: 0 auto;
    color: red;
    text-align: center;
}
.conteneurPrixRaquettes {
	width: 35%;
	float: left;
	height: 100%;
	overflow: hidden;
	    position: relative;
}
.PVCRaquettes {
     color: #000;
    display: flex;
    flex-direction: column;
    font-size: 12px;
    text-decoration: line-through;
    background: #ffff;
    position: relative;
	    margin-top: 10px;
		 margin-right: 2px;
}
.PVCRaquettes img{
	   height: 40px;
}
.PVCRaquettesPrice{
	    position: absolute;
    top: 10px;
    right: 10px;
    text-align: right;
    width: 100%;
	    font-size: 13px;
}
.PVCRaquettesPrice span{
	text-decoration: line-through;
}
/* conteneur représentant la partie gauche de l'étiquette (logo, ref, caractéristiques) */
.smallSizeEtiquetteRaquettes {
  color: black;
  display: flex;
  justify-content: center;
  align-items: center;
  font-size: 20px;
  font-weight: 600;
}

.caracteristiquesProduitRaquettes {
        color: black;
    font-weight: 600;
    font-size: 10px;
    position: absolute;
    bottom: 5px;
    text-align: center;
    width: 100%;
}

/* conteneur représentant la partie droite de l'étiquette (PVC, logo P2B ou Promo, PV) */


.logoP2BouPromoRaquettes {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
	      margin: 20px 0 5px;
}

.PVRaquettes img {
  height: 40px;
}

.PVRaquettes {
    color: white;
    display: flex;
    flex-direction: column;
    font-size: 22px;
    font-weight: 600;
	    position: relative;
		 margin-right: 2px;
}
.PVRaquettesPrice{
	    position: absolute;
    top: 2px;
    right: 10px;
    text-align: right;
    width: 100%;
}
@media print {
	.no-print{
		display: none !important;
	}
  table { page-break-after:auto }
  table tr    { page-break-inside:avoid; page-break-after:auto }
  table thead { display:table-header-group }
  table tfoot { display:table-footer-group }
  .page-break  { display: block; page-break-before: always; }
  .no-padding-print{ padding-left: 0 !important;}
  .no-margin-print{margin-top: 0;}
  .no-margin-top-left{ margin-top: 0; margin-left: 0;}
 }
 @media screen and (max-width: 50em) {
  .Logo2bad-login{
	width: 100%;
  }
}
`, "",{"version":3,"sources":["webpack://./src/styles/EtiquetteRaquettes.css"],"names":[],"mappings":"AAAA,oDAAoD;AACpD;IACI,wBAAwB;AAC5B;AACA;;;;IAII,wBAAwB;AAC5B;AACA;EACE,aAAa;EACb,WAAW;EACX,mBAAmB;AACrB;AACA;CACC,aAAa;CACb,WAAW;AACZ;AACA;CACC,eAAe;IACZ,WAAW;AACf;AACA;QACQ,yBAAyB;IAC7B,WAAW;IACX,mBAAmB;IACnB,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,UAAU;IACV,YAAY;IACZ,eAAe;IACf,iBAAiB;AACrB;AACA;IACI,aAAa;IACb,uBAAuB;MACrB,gBAAgB;AACtB;AACA;IACI,eAAe;IACf,iBAAiB;IACjB,iBAAiB;AACrB;AACA;IACI,UAAU;AACd;AACA,iBAAiB,gBAAgB,CAAC;AAClC;CACC,gBAAgB;CAChB,iBAAiB;AAClB;AACA;CACC,cAAc;CACd,aAAa;CACb,WAAW;AACZ;AACA;CACC,6BAA6B;AAC9B;AACA;CACC,UAAU;IACP,WAAW;CACd,kBAAkB;CAClB,YAAY;AACb;AACA;IACI,kBAAkB;IAClB,QAAQ;IACR,SAAS;AACb;AACA;IACI,WAAW;AACf;AACA;CACC,kBAAkB;IACf,SAAS;IACT,SAAS;IACT,2BAA2B;KAC1B,iBAAiB;AACtB;AACA;CACC,YAAY;AACb;AACA;CACC,kBAAkB;IACf,QAAQ;IACR,SAAS;IACT,gCAAgC;IAChC,WAAW;IACX,kBAAkB;IAClB,cAAc;AAClB;AACA;KACK,eAAe;IAChB,gBAAgB;IAChB,UAAU;IACV,cAAc;IACd,UAAU;IACV,kBAAkB;AACtB;AACA;CACC,UAAU;CACV,WAAW;CACX,YAAY;CACZ,gBAAgB;KACZ,kBAAkB;AACvB;AACA;KACK,WAAW;IACZ,aAAa;IACb,sBAAsB;IACtB,eAAe;IACf,6BAA6B;IAC7B,iBAAiB;IACjB,kBAAkB;KACjB,gBAAgB;GAClB,iBAAiB;AACpB;AACA;IACI,YAAY;AAChB;AACA;KACK,kBAAkB;IACnB,SAAS;IACT,WAAW;IACX,iBAAiB;IACjB,WAAW;KACV,eAAe;AACpB;AACA;CACC,6BAA6B;AAC9B;AACA,yFAAyF;AACzF;EACE,YAAY;EACZ,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,eAAe;EACf,gBAAgB;AAClB;;AAEA;QACQ,YAAY;IAChB,gBAAgB;IAChB,eAAe;IACf,kBAAkB;IAClB,WAAW;IACX,kBAAkB;IAClB,WAAW;AACf;;AAEA,wFAAwF;;;AAGxF;EACE,aAAa;EACb,sBAAsB;EACtB,uBAAuB;EACvB,mBAAmB;OACd,kBAAkB;AACzB;;AAEA;EACE,YAAY;AACd;;AAEA;IACI,YAAY;IACZ,aAAa;IACb,sBAAsB;IACtB,eAAe;IACf,gBAAgB;KACf,kBAAkB;GACpB,iBAAiB;AACpB;AACA;KACK,kBAAkB;IACnB,QAAQ;IACR,WAAW;IACX,iBAAiB;IACjB,WAAW;AACf;AACA;CACC;EACC,wBAAwB;CACzB;EACC,QAAQ,sBAAsB;EAC9B,cAAc,uBAAuB,EAAE,sBAAsB;EAC7D,cAAc,2BAA2B;EACzC,cAAc,2BAA2B;EACzC,eAAe,cAAc,EAAE,yBAAyB,EAAE;EAC1D,mBAAmB,0BAA0B,CAAC;EAC9C,iBAAiB,aAAa,CAAC;EAC/B,qBAAqB,aAAa,EAAE,cAAc,CAAC;CACpD;CACA;EACC;CACD,WAAW;EACV;AACF","sourcesContent":["/* conteneur englobant l'ensemble des informations */\ntable{\n    border-collapse:collapse;\n}\ntable,\ntr,\ntd,\ndiv {\n    page-break-inside: avoid;\n}\n.EtiquetteRaquettes{\n  width: 11.5cm;\n  height: 4cm;\n  border: solid 0.1px;\n}\n.EtiquetteRaquettesSize{\n\twidth: 11.5cm;\n\theight: 4cm;\n}\n.dlpro-manufacturer-name-custom{\n\tfont-size: 10px;\n    width: 100%;\n}\n.logoP2BouPromoRaquettesPromo {\n        background-color: #e8182e;\n    color: #fff;\n    border-radius: 50px;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    width: 60%;\n    height: 25px;\n    font-size: 10px;\n    font-weight: bold;\n}\n.logoP2BouPromoRaquettesPrixDebad{\n\t   display: flex;\n    justify-content: center;\n      align-items: end;\n}\n.logoP2BouPromoRaquettesPrixDebad span {\n    font-size: 13px;\n    margin-right: 2px;\n    line-height: 15px;\n}\n.logoP2BouPromoRaquettesPrixDebad img {\n    width: 40%;\n}\n.no-margin-print{margin-top: 20px;}\n.no-margin-top-left{\n\tmargin-top: 20px;\n\tmargin-left: 25px;\n}\n.conteneurEtiquetteRaquettes {\n\tdisplay: block;\n\twidth: 11.5cm;\n\theight: 4cm;\n}\n.no-padding-print{\n\tpadding-left: 90px !important;\n}\n.conteneurCaracteristiquesRaquettes {\n\twidth: 65%;\n    float: left;\n\tposition: relative;\n\theight: 100%;\n}\n.raquettesCheckGreen {\n    position: absolute;\n    top: 5px;\n    left: 5px;\n}\n.raquettesCheckGreen img{\n    width: 20px;\n}  \n.raquettesBlockTop{\n\tposition: absolute;\n    top: 20px;\n    left: 50%;\n    transform: translateX(-50%);\n\t    margin-top: -10px;\n}\n.raquettesBlockTop img{\n\twidth: 110px;\n}\n.raquettesBlockCenter{\n\tposition: absolute;\n    top: 50%;\n    left: 50%;\n    transform: translate(-50%, -50%);\n    width: 100%;\n    text-align: center;\n    margin: 10px 0;\n}\n.bigSizeEtiquetteRaquettes {\n     font-size: 18px;\n    font-weight: 600;\n    width: 90%;\n    margin: 0 auto;\n    color: red;\n    text-align: center;\n}\n.conteneurPrixRaquettes {\n\twidth: 35%;\n\tfloat: left;\n\theight: 100%;\n\toverflow: hidden;\n\t    position: relative;\n}\n.PVCRaquettes {\n     color: #000;\n    display: flex;\n    flex-direction: column;\n    font-size: 12px;\n    text-decoration: line-through;\n    background: #ffff;\n    position: relative;\n\t    margin-top: 10px;\n\t\t margin-right: 2px;\n}\n.PVCRaquettes img{\n\t   height: 40px;\n}\n.PVCRaquettesPrice{\n\t    position: absolute;\n    top: 10px;\n    right: 10px;\n    text-align: right;\n    width: 100%;\n\t    font-size: 13px;\n}\n.PVCRaquettesPrice span{\n\ttext-decoration: line-through;\n}\n/* conteneur représentant la partie gauche de l'étiquette (logo, ref, caractéristiques) */\n.smallSizeEtiquetteRaquettes {\n  color: black;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  font-size: 20px;\n  font-weight: 600;\n}\n\n.caracteristiquesProduitRaquettes {\n        color: black;\n    font-weight: 600;\n    font-size: 10px;\n    position: absolute;\n    bottom: 5px;\n    text-align: center;\n    width: 100%;\n}\n\n/* conteneur représentant la partie droite de l'étiquette (PVC, logo P2B ou Promo, PV) */\n\n\n.logoP2BouPromoRaquettes {\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n  align-items: center;\n\t      margin: 20px 0 5px;\n}\n\n.PVRaquettes img {\n  height: 40px;\n}\n\n.PVRaquettes {\n    color: white;\n    display: flex;\n    flex-direction: column;\n    font-size: 22px;\n    font-weight: 600;\n\t    position: relative;\n\t\t margin-right: 2px;\n}\n.PVRaquettesPrice{\n\t    position: absolute;\n    top: 2px;\n    right: 10px;\n    text-align: right;\n    width: 100%;\n}\n@media print {\n\t.no-print{\n\t\tdisplay: none !important;\n\t}\n  table { page-break-after:auto }\n  table tr    { page-break-inside:avoid; page-break-after:auto }\n  table thead { display:table-header-group }\n  table tfoot { display:table-footer-group }\n  .page-break  { display: block; page-break-before: always; }\n  .no-padding-print{ padding-left: 0 !important;}\n  .no-margin-print{margin-top: 0;}\n  .no-margin-top-left{ margin-top: 0; margin-left: 0;}\n }\n @media screen and (max-width: 50em) {\n  .Logo2bad-login{\n\twidth: 100%;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
